// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__xd31F","vLegacy":"SelectSecondary_vLegacy__3Y6YC","error":"SelectSecondary_error__1xbmx","disabled":"SelectSecondary_disabled__3mSnY"};